<template>
  <div class="rightPanel new_rightPanel" v-show="helpModal" v-clickoutside="hide">
    <el-card class="box-card" shadow="hover">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-loading="newsLoading">
        <el-tab-pane :label="$ts('帮助')" name="71">
          <div class="item" v-for="item in helpList" :key="item.id" @click="goPage('帮助', item.id)">
            {{ item.title }}
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$ts('新闻')" name="72">
          <div class="ellips item" v-for="(item, index) in newsList" :key="index" @click="goPage('新闻', item.id)">
            {{ item.title }}
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$ts('产品')" name="73">
          <div class="ellips item" v-for="(item, index) in noticeList" :key="index" @click="goPage('产品', item.id)">
            {{ item.title }}
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-card class="box-card box-card2" shadow="hover">
      <div class="download_boxs">
        <div class="code_boxs">
          <div>{{$ts('工作APP端')}}</div>
          <img class="code2_img" src="@/static/FIR-ordering.png" preview="0" :preview-text="$ts('二维码')"
            v-if="$projectType==1" />
          <img class="code2_img" src="@/static/FIR-SugCloud.png" preview="0" :preview-text="$ts('二维码')"
            v-else-if="$projectType==2" />
          <img class="code2_img" src="@/static/FIR-youlianyun.png" preview="0" :preview-text="$ts('二维码')"
            v-else-if="$projectType==4" />
          <img class="code2_img" src="@/static/FIR-zhonglun.png" preview="0" :preview-text="$ts('二维码')"
            v-else-if="$projectType==6" />
          <img class="code2_img" src="@/static/FIR-wiwipu.png" preview="0" :preview-text="$ts('二维码')" v-else />
        </div>

        <div class="code_boxs">
          <div>{{$ts('分包分拣端')}}</div>
          <a style="color: white" target="_blank" :href="zipUrl">
            <img class="download_btn" src="@/static/img-fj-zlgyl.png" :alt="$ts('分包分拣端')" v-if="$projectType==6" />
            <img class="download_btn" src="@/static/img-fj-yly.png" :alt="$ts('分包分拣端')" v-else-if="$projectType==4" />
            <img class="download_btn" src="@/static/img-fj.png" :alt="$ts('分包分拣端')" v-else />
          </a>
        </div>
      </div>
      <div class="mobile_boxs">
        <div class="mobile_boxs_left">
          <div class="customer_phone" v-if="$projectType==4">{{$ts('客服电话')}}：19936103209 </div>
          <div class="customer_phone" v-else>{{$ts('客服电话')}}：13319508477 </div>
        </div>
        <div>
          {{$ts('欢迎在售后客服')}}<br>{{$ts('微信群反馈交流')}}
        </div>
        <!-- <img class="qq_icon" style="cursor: pointer"
          onclick="javascript:window.open('http://b.qq.com/webc.htm?new=0&sid=93734726&o=蔬果云生鲜系统&q=7', '_blank', 'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no');"
          border="0" src="http://wpa.qq.com/pa?p=1:93734726:3" alt="点击这里给我发消息" /> -->
      </div>
    </el-card>
    <div class="box-card box-card3" v-loading="loading">
      <div class="clearfix headers"><span>{{$ts('导出下载')}}</span></div>
      <div class="headerss" @click="getDownloadList">
        <div class="icon-fresh"></div><span>{{$ts('刷新')}}</span>
      </div>
      <div class="load_box">
        <div class="down_item" v-for="item in downloadList" :key="item.id">
          <div>
            <div style="line-height: 20px">{{ item.create_time_str }}</div>
            <div style="line-height: 20px">
              {{ item.type_str }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.status == 2 ? $ts('处理失败') : item.status_str }}
            </div>
          </div>
          <div v-if="item.status == 2">
            {{$ts('请重新筛选导出')}}
          </div>
          <el-button class="down-btn" size="mini" type="danger" v-if="item.show_btn" @click="downLoading(item.file)">
            <div class="icon-down"></div>{{$ts('下载')}}
          </el-button>
          <div class="down_content" v-if="item.fail_msg != null && item.fail_msg != ''">
            <div class="down_content_li">
              <div class="li_title" :class="{red:item.status==2,green:item.status==1}">{{$ts('错误信息')}}</div>
              <div class="li_content" v-html="item.fail_msg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import clickoutside from 'element-ui/src/utils/clickoutside'
  export default {
    name: "help-modal",
    directives: {
      clickoutside
    },
    data() {
      return {
        helpModal: false,
        newsLoading: false,
        loading: false,
        bodyStyle: {
          padding: "0 20px 20px",
        },
        activeName: "71",
        newsList: [],
        helpList: [],
        noticeList: [],
        downloadList: [],
        timer: null
      };
    },
    computed: {
      zipUrl() {
        // pc.justgreen168.com/SugCloud-Pick.zip
        let zipUrl = '';
        switch (this.$projectType) {
          case 6:
            // 中仑供应链
            zipUrl = 'https://zhonglunnet-scm-gs.oss-cn-shanghai.aliyuncs.com/delivery_soft/hard.zip';
            break;
          case 5:
            // 新加坡-展维美菜
            zipUrl = 'https://zhanweimeicai.oss-ap-southeast-1.aliyuncs.com/delivery_soft/hard.zip';
            break;
          case 4:
            // 优链云
            zipUrl = 'https://youlianyun.oss-cn-guangzhou.aliyuncs.com/delivery_soft/hard.zip';
            break;
          case 2:
            // 泰国
            zipUrl = 'https://justgreen168.oss-ap-southeast-7.aliyuncs.com/SugCloud-Pick.zip';
            break;
          default:
            zipUrl = 'https://sgydev.douhuomall.com/uploads/hard.zip';
        }
        return zipUrl
      }
    },
    mounted() {
      this.handleClick()
      this.getDownloadList();
      this.$bus.$on("downloading", () => {
        this.getDownloadList();
      });
    },
    beforeDestroy() {
      this.$bus.$off('downloading')
    },
    methods: {
      toggle(show) {
        this.helpModal = !this.helpModal;
        if (this.helpModal) {
          let num = 0,
            array = ["71", "72", "73"];
          this.activeName = array[num];
          this.timer = setInterval(() => {
            num++;
            if (num == 3) {
              num = 0;
            }
            this.activeName = array[num];
            this.handleClick()
          }, 4000);
        } else {
          this.hide()
        }
      },
      hide() {
        if (this.helpModal) {
          this.helpModal = false;
          clearTimeout(this.timer)
        }
      },
      goPage(type, id) {
        window.open(
          this.url + "/manager/#/news-content?type=" + type + "&id=" + id
        );
      },
      getDownloadList() {
        this.loading = true;
        this.request({
          url: "/admin/file_task/index",
          data: {},
          is_public: true,
          complete: (res) => {
            this.loading = false;
            let list = res.data;
            list.map(item => {
              if (item.status == 1 && item.export_str === 'out') {
                item.show_btn = true;
              } else {
                item.show_btn = false;
              }
            })
            this.downloadList = list;
          },
        });
      },
      downLoading(path) {
        window.open(this.url + path);
      },
      getnewsList(val) {
        if (val == 71 && this.helpList.length) {
          return
        } else if (val == 72 && this.newsList.length) {
          return
        } else if (val == 73 && this.noticeList.length) {
          return
        }
        let params = {
          page: 1,
          type: val,
          page_num: 5,
        };
        this.newsLoading = true;
        this.request({
          url: "/api/article/articlelist",
          data: params,
          is_public: true,
          complete: (res) => {
            this.newsLoading = false;
            if (res.error_code == 0) {
              if (val == 71) {
                this.helpList = res.data.slice(0, 4);
              }
              if (val == 72) {
                this.newsList = res.data.slice(0, 4);
              }
              if (val == 73) {
                this.noticeList = res.data.slice(0, 4);
              }
            }
            if (res.error_code == 1) {
              this.$message.error(res.error_msg);
            }
          },
        });
      },
      handleClick() {
        this.getnewsList(this.activeName)
      },
    },
  };
</script>

<style scoped>
  .rightPanel {
    position: relative;
    width: 300px;
    height: 100%;
    float: right;
    overflow: auto;
    margin-top: 10px;
    padding-right: 10px;
  }

  .new_rightPanel {
    position: fixed;
    z-index: 120;
    right: 0;
    top: 45px;
    width: 400px;
    height: calc(100% - 85px);
    overflow: auto;
    background-color: #ffffff;
    box-shadow: 0px 3px 30px 0px rgba(0, 0, 0, 0.25);
    border-radius: 10px 0px 0px 10px;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .new_rightPanel .el-card {
    margin: 0;
    border: none;
    border-bottom: 1px solid #EBEEF5;
  }

  .download_boxs {
    display: flex;
    justify-content: space-between;
  }

  .download_btn {
    width: 60px;
    height: 60px;
    margin: 10px 0px !important;
  }

  .code_boxs {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;
  }

  .isShowStyle .close_right {
    margin-top: 10px;
  }

  .rightPanel::-webkit-scrollbar {
    width: 0;
  }

  .panel-title {
    border-bottom: 1px solid #f0f0f0;
  }

  .box-card {
    margin-bottom: 10px;
    border-radius: 5px;
  }

  .customer_phone {
    padding: 7px 0px;
    font-size: 14px;
    color: var(--theme-color1);
  }

  .rightPanel .item {
    font-size: 14px;
    padding: 10px 0;
    cursor: pointer;
  }

  .text {
    font-size: 16px;
    line-height: 0.8;
  }

  .ellips {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-tabs__nav-wrap::after {
    background-color: transparent;
  }

  .el-tabs__item:hover,
  .el-tabs__item.is-active {
    color: var(--theme-color);
  }

  .clearfix {
    color: var(--theme-color);
  }

  .el-tabs__active-bar {
    background-color: var(--theme-color);
  }

  .themecolor:focus,
  .themecolor:hover {
    background-color: var(--theme-color);
    color: #fff;
  }

  .themecolor {
    background-color: var(--theme-color);
    color: #fff;
    font-size: 15px;
    border: none;
  }

  .code2_img {
    width: 60px;
    height: 60px;
    margin: 10px 0px;
  }

  .box-card3 {
    width: 296px;
    background-color: #ffffff;
    box-sizing: border-box;
    padding: 20px;
    position: relative;
    overflow-style: none;
  }

  .new_rightPanel .box-card3 {
    width: 100%;
  }

  .el-card__header {
    padding: 0;
    border: none;
  }

  .headers {
    position: absolute;
    top: 0;
    box-sizing: border-box;
    padding: 18px 20px;
  }

  .headerss {
    position: absolute;
    top: 0;
    right: 0;
    box-sizing: border-box;
    padding: 18px 20px;
    cursor: pointer;
  }

  .new_rightPanel .headerss {
    display: flex;
    align-items: center;
  }

  .new_rightPanel .icon-fresh {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    background-image: url('~@/static/icon-fresh.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .new_rightPanel .icon-down {
    display: inline-block;
    width: 16px;
    height: 15px;
    margin-right: 5px;
    background-image: url('~@/static/icon-down.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    transform: translateY(2px);
  }

  .new_rightPanel .down-btn {
    display: flex;
    align-content: center;
    justify-content: center;
    background-color: #f5f5f5;
    border-radius: 25px;
    font-size: 14px;
    color: #ff904e;
    width: 90px;
    border: none;
  }

  .load_box {
    height: 250px;
    overflow-y: auto;
    margin-top: 30px;
  }

  .down_item {
    padding: 10px 0;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .mobile_boxs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }

  .qq_icon {
    width: 100px;
    height: 30px;
    flex-shrink: 0;
  }

  .pop {
    width: 300px;
    height: 400px;
    position: fixed;
    z-index: 9999;
    bottom: 0;
    right: 0;
    background-color: #ffffff;
    border: 1px solid #cccccc;
    box-shadow: 2px 2px 10px #000;
  }

  .message_icon_box {
    display: flex;
    align-items: center;
    position: relative;
  }

  .customer_icon {
    position: absolute;
    bottom: -12px;
  }

  .pop_top {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--theme-color);
    color: #ffffff;
  }

  .pop_top p {
    font-size: 16px;
    box-sizing: border-box;
    padding: 18px 20px 18px 100px;

  }

  .close {
    width: 30px;
    height: 30px;
    color: #000000;
    position: absolute;
    color: #ffffff;
    font-size: 30px;
    right: 10px;
    top: 10px;
  }

  .down_content {
    width: 100%;
    overflow-y: auto;
  }

  .down_content_li {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    position: relative;
    border-bottom: 1px solid #cccccc;
    cursor: pointer;
  }

  .down_content span {
    font-size: 12px;
  }

  .down_content_li div {
    font-size: 14px;
    line-height: 24px;
  }

  .li_title {
    color: var(--theme-color);
  }

  .li_content {
    color: #666666;
    font-size: 12px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar/HelpModal.vue